module.exports = __webpack_public_path__ + "static/assets/fca669c8d4c484e242ee3140cd223e9f.svg";